module.exports = __webpack_public_path__ + "static/media/marcos_da_silva_e_souza.19e83bf6.jpg";